
const ViewTabsWrapper = ({ children }: { children: React.ReactNode | React.ReactNode[] }) => {
    return (
        <div className="w-fit flex absolute top-[9px] left-0 gap-[var(--spacing-xs)]">
            {children}
        </div>
    )
}

export default ViewTabsWrapper